// extracted by mini-css-extract-plugin
module.exports = {"invitations":"ReferralHistory_invitations__2T-Lr","container":"ReferralHistory_container__3TrQd","reminder":"ReferralHistory_reminder__1mOfT"};